import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./DeleteItemModal.module.css";

interface Props {
  title: string;
  text: string;
  deleteButtonText: string;
  onDelete: () => void;
  onClose: () => void;
}

const DeleteItemModal: React.FC<Props> = ({
  title,
  text,
  deleteButtonText,
  onDelete,
  onClose,
}: Props) => {
  return (
    <Modal className={styles.modal} closeModal={onClose}>
      <Text variant={"title2"} className={styles.title}>
        {title}
      </Text>

      <Text variant="body" color={"textSubtle"}>
        {text}
      </Text>

      <div className={styles.footer}>
        <Button
          text={"Cancel"}
          variant={"outlined"}
          buttonType={"secondary"}
          onClick={onClose}
          sx={{ width: "80px" }}
        />

        <Button
          text={deleteButtonText}
          variant={"outlined"}
          buttonType={"warning"}
          onClick={onDelete}
          sx={{ marginLeft: "20px", width: "120px" }}
        />
      </div>
    </Modal>
  );
};

export default DeleteItemModal;
